import util from "./util.js"; // getType 获取数据类型
// import ajax from './ajax.js'
const { formatDate, getType, formatSize } = util;
export default {
  data() {
    const empty1 = require("@/assets/img/empty.png");
    const empty2 = require("@/assets/img/empty3.png");
    return {
      // 声明几个通用的字段
      // imgError: empty1,
      userError: 'this.src="' + require("@/assets/img/me.png") + '"',
      logoError: 'this.src="' + require("@/assets/img/home/63.png") + '"',
      empty1,
      empty2,
      page: 1,
      isLoading: false,
      list: [],
      count: 0,
    };
  },
  filters: {
    filterName(v, num = 1) {
      const list = v.split(",");
      if (list.length <= num) {
        return v;
      }
      return list[0] + "等" + list.length + "人";
    },
  },
  /* eslint-disable */
  methods: {
    imgError(event) {
      console.log("imgError", event);
      event.target.src = this.empty1;
    },
    toUrl(params, _blank = true) {
      if (_blank) {
        window.open(this.$router.resolve(params).href, "_blank");
      }
    },
    formatDate,
    formatSize,
    getType,
    formatTime(seconds) {
      // 把秒数转化为00:00
      if (!Number(seconds)) {
        return ["00", "00", "00"];
      }
      const result = [];
      const hours = Math.floor(seconds / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);
      const remainingSeconds = seconds % 60;
      result.push(hours.toString().padStart(2, "0"));
      result.push(minutes.toString().padStart(2, "0"));
      result.push(remainingSeconds.toString().padStart(2, "0"));
      return result;
    },
    openImg(src, msg = "查看图片") {
      const fail = () => {
        this.$message("图片加载失败");
      };
      console.log(src);
      if (src) {
        const IMG = new Image();
        IMG.src = src;
        IMG.onload = () => {
          this.$alert(
            "<img src=" + src + ' style="max-width:100%;max-height:100%" />',
            {
              dangerouslyUseHTMLString: true,
              showConfirmButton: false,
              customClass: "open-img",
            }
          );
        };
        IMG.onerror = () => {
          fail();
        };
      } else {
        fail();
      }
    },
  },
};
